import { useEffect, useState } from "react";
import axiosInstance from "../../services/axiosInstance";
import { useNavigate } from "react-router-dom";
import { useBreadcrumbs } from "../../contexts/BreadcrumbContext";

const PrescriptionHistory = ({ customerId }) => {
    const [prescriptions, setPrescriptions] = useState([]);
    const navigate = useNavigate();
    const { push, beginDrilldown } = useBreadcrumbs();

    useEffect(() => {
        const fetchPrescriptions = async () => {
            try {
                const response = await axiosInstance.get(`/api/prescriptions/history-for-customer/${customerId}`);
                setPrescriptions(response.data);
            } catch (error) {
                console.error("Failed to load prescriptions", error);
            }
        };

        fetchPrescriptions();
    }, [customerId]);

    const handleRowClick = (prescription) => {
        beginDrilldown();
        navigate(`/prescriptions`, {
            state: {
                prescriptionId: prescription.id, // Pass the selected prescription ID
                customerId: prescription.customer // Pass the customer ID
            },
        });
        push({
            label: `Customer: ${prescription.customer_name}`,
            path: `/customers/${customerId}`,
        });
        push({
            label: `Prescriptions`,
            path: '/prescriptions',
        });
        push({
            label: `Prescription: ${prescription.id}`,
            path: '/prescriptions',
            state: { prescriptionId: prescription.id }
        });
    };

    return (
        <div className="p-4 rounded-lg shadow">
            <h3 className="text-lg font-semibold">Prescription History</h3>
            {prescriptions.length === 0 ? (
                <p>No prescriptions found.</p>
            ) : (
                <ul>
                    {prescriptions.map((prescription) => (
                        <li key={prescription.id} className="border-b p-2" onClick ={() => {handleRowClick(prescription)}} style={{cursor:'pointer'}}>
                                {prescription.date} - Dr.{prescription.doctor_name}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default PrescriptionHistory;
